import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-insurance',
  templateUrl: './blog-insurance.component.html',
  styleUrls: ['./blog-insurance.component.scss']
})
export class BlogInsuranceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
